const constant = {
  userType: {admin: 1, honbu: 2, admin_pharm: 4, pharm: 8, admin_pc: 16, pc: 32, krr_carman: 64, mi_clinic: 128, mi_careoffice: 256, mi_facility: 512, etc: 0},

  // 店舗切替表示チェック対象URL
  // ページ遷移時に、店舗切替画面を表示する必要 があるパスを追記する
  SELECT_SHOP_PATHS: [
    /^\/facilities\?type=create_report/,             // 報告書作成（施設選択）
    /^\/patients\/.*\/select\/\?type=create_report/, // 報告書作成（患者選択）
    /^\/reports\/.*\/edit/,                          // 報告書作成・編集
    /^\/facilities\?type=reports_history/,           // 報告書送信履歴（施設選択）
    /^\/facility_persons\?type=reports_history/,     // 報告書送信履歴（個人宅選択）
    /^\/clinics\?type=reports_history/,              // 報告書送信履歴（クリニック選択）
    /^\/care_offices\?type=reports_history/,         // 報告書送信履歴（介護支援事業所選択）
    /^\/reports\/history/,                           // 報告書送信履歴
    /^\/reports\/batch_history/                      // 報告書送信履歴（バッチ側）
  ],

  js: {
    google_maps: 'maps.google.com/maps/api/js?sensor=false' // google map
  },
  html: {
    loading: './static/html/loading.html', // 読み込み中HTML
    error: './static/html/error.html?msg=' // エラー表示HTML
  },
  // マップデフォルト 福岡市
  map_default: {
    lat: 33.589085,
    lng: 130.412232,
    zoom: 11
  },
  // アイコン
  currentShopIcon: './static/images/shop_white.png',
  shopIcons: [
    './static/images/shop_red.png',
    './static/images/shop_blue.png',
    './static/images/shop_purple.png',
    './static/images/shop_grey.png',
    './static/images/shop_orange.png',
    './static/images/shop_green.png',
    './static/images/shop_white.png',
    './static/images/shop_black.png'
  ],
  // アイコン
  resIcons: [
    './static/images/marker_red.png',
    './static/images/marker_blue.png',
    './static/images/marker_purple.png',
    './static/images/marker_grey.png',
    './static/images/marker_orange.png',
    './static/images/marker_green.png',
    './static/images/marker_white.png',
    './static/images/marker_black.png'
  ],
  phraseType: {
    EMERGENCY_REL: 1,             // 計画書―続柄
    PAY_METHOD: 2,                // 計画書―お支払い方法
    SIDE_EFFECT_HISTORY: 3,       // 計画書―副作用歴
    ALLERGY_HISTORY: 4,           // 計画書―アレルギー歴
    VISIT_INTERVAL: 5,            // 計画書―訪問回数
    DISEASE: 6,                   // 計画書―診断名
    BODY_CHARACTER: 7,            // 計画書―患者の心身の特性・注意すべき点
    COMPLICATION: 8,              // 計画書―合併症・既往歴
    LEAD_PLAN: 9,                 // 計画書―服薬支援服薬指導計画
    PRESCRIBE_CHANGE: 10,         // 報告書―処方内容変更点
    CONSULT_POINT: 11,            // 報告書―本人、介護者からの相談事項の要点
    TAKING_POINT: 12,             // 報告書―服薬指導の要点
    SPECIAL_COMMENT: 13,          // 報告書―特記事項申し送り
    REMNANT_CONFIRM: 14,          // 報告書―残薬状況の確認
    VITAL_CHECK: 15,              // 報告書―バイタルチェック
    HANDBOOK_STATUS: 16,          // 報告書―手帳による情報提供の状況
    TAKING_CONFIRM: 17,           // 報告書―服薬状況の確認
    INTERACTION_CONFIRM: 18,      // 報告書―相互作用の確認
    TAKE_INTERACTION_CONFIRM: 19, // 報告書―服用薬と相互作用のある飲食物の摂取の確認
    COMPLICATION_INFO: 20,        // 報告書―他科受診、合併症の情報
    OTHER_DOSAGE_INFO: 21,        // 報告書―他科からの投薬の情報
    OTC_COMBINATION_INFO: 22,     // 報告書―ＯＴＣの併用の情報
    MED_MANAGER: 23,              // 報告書―薬の管理者
    MED_MANAGER_INFO: 24,         // 報告書―薬の管理者情報
    MANAGE_METHOD: 25,            // 報告書―管理方法
    MANAGE_METHOD_INFO: 26,       // 報告書―管理方法情報
    VISIT_DUTY_INFO: 27,          // 報告書―義務照会情報
    DISPENSE_RECORD: 28,          // 報告書―調剤についての記録
    TAKING_PERIOD: 29,            // 報告書―処方日数
    CONSULT_POINT1: 30,           // 報告書―(体調)本人、介護者からの相談事項の要点
    CONSULT_POINT2: 31,           // 報告書―(体調)本人、介護者からの相談事項の要点
    CONSULT_POINT3: 32,           // 報告書―(体調)本人、介護者からの相談事項の要点
    CONSULT_POINT4: 33,           // 報告書―(体調)本人、介護者からの相談事項の要点
    FACILITY_TYPE: 34,            // 施設種類
    TAKING_METHOD: 35,            // 報告書―服用期間（用法）
    UHOLIDAY_TYPE: 36,            // 社員休暇―休み種類
    SHIFT_ONCALL: 37,             // シフト表ーオンコール
    SHIFT_BUSINESS: 38,           // シフト表ー業務
    FACILITY_PAY: 39              // 施設支払方法
  },
  // 計画書
  plan: {
    // 入力上限
    textarea: {
      /**
       * lineFeed:       改行の上限
       * lenMax:        １行の最大文字数（超えた場合は１改行と見なす）(半角1、全角2)
       * isOneLineCalc: １行のみの場合 文字数 / lenMaxでの改行制限計算を行うか ※省略時はfalse
       * ajast:         isOneLineCalc = true を指定した場合の調整行
       */
      visit_plan: {lineFeed: 3, lenMax: 114},      // 訪問計画
      body_character: {lineFeed: 2, lenMax: 114},  // 患者の心身の特性 注意すべき点
      complication: {lineFeed: 2, lenMax: 114},    // 合併症・既往歴
      special_comment: {lineFeed: 7, lenMax: 114}, // 特記事項・調剤訪問における注意事項
      meeting_comment: {lineFeed: 8, lenMax: 114}  // 担当者会議出席記録
    }
  },
  // 報告書
  report: {
    // 入力上限
    textarea: {
      /**
       * lineFeed:      改行の上限
       * lenMax:        １行の最大文字数（超えた場合は１改行とする）(半角1、全角2)
       * isOneLineCalc: １行のみの場合 文字数 / lenMaxでの改行制限計算を行うか ※省略時はfalse
       * ajast:         isOneLineCalc = true を指定した場合の調整行
       */
      prescribe_change: {lineFeed: 5, lenMax: 50},                               // 変更点
      soap_comment: {lineFeed: 11, lenMax: 50},                                  // 指導内容
      confirm_comment: {lineFeed: 11, lenMax: 50}                                // 確認事項
      // confirm_comment: {lineFeed: 11, lenMax: 26, isOneLineCalc: true, ajast: 1} // 確認事項
    },
    // 報告書種類
    report_type: {
      none: '',                       // -
      kyotaku: 'kyotaku',             // 居宅療養管理指導
      yakureki: 'yakureki',           // 薬歴
      yakuzai_kanri: 'yakuzai_kanri', // 在宅患者訪問薬剤管理指導
      no_report: 'no_report',         // 報告なし
      yaku_shidou: 'yaku_shidou',     // かかりつけ薬剤師指導
      yaku_houkatsu: 'yaku_houkatsu'  // かかりつけ薬剤師包括管理
    },
    // 送信状態
    post_status: {
      temp: 'temp',      // 一時保存
      post: 'post',      // 送信状態
      no_post: 'no_post' // 未送信(完了)
    },
    // 処方
    method_type: {
      method_none: 0,    // -
      method_morning: 1, // 朝
      method_noon: 2,    // 昼
      method_evening: 3, // 夕
      method_bedtime: 4  // 就寝前
    },
    // 提出
    send_check: 1, // ON状態
    // 送信時間
    send_timing_hour_default: '0.0',
    // 送信時間
    default_time: '7:00',
    // バッチ種類
    batch_type: {
      batch: 'batch',       // 定期送信
      instance: 'instance', // 即時送信
      stop: 'stop',         // 停止
      restart: 'restart'    // 再送信
    },
    send_status: {
      success: 1,
      fail: 2,
      sending: 3
    },
    failure: 0, // 不良
    good: 1,    // 良
    nashi: 0,   // 無
    ari: 1,     // 有
    // 送付方法
    send_timing: {
      same_day: 0, // 当日○時間後送付
      week1: 1,    // １週間まとめ送付
      week2: 2     // ２週間まとめ送付
    },
    // 日付一括
    bulk_date_type: {
      shohou: 1,  // 処方日
      chouzai: 2, // 調剤日
      houmon: 3,  // 訪問日
      hukuyou: 4  // 服薬期間
    },
    // エクセル情報
    xls: {
      roomno_nashi: '2', // 部屋番号なし
      roomno_ari: '3',   // 部屋番号あり
      haiyaku1: '10',    // 配薬
      haiyaku2: '11',    // 今回配薬
      henkou: '12',      // 変更点
      shidou: '13',      // 指導
      kakunin: '14',     // 確認事項
      kakunin2: '15'     // 確認事項2行目
    }
  },
  // 有効フラグ
  enable_flag: {
    on: 1, // 有効
    off: 0 // 無効
  },
  facility: {
    login_id_prefix: 'KS',
    facility_person_type: 1,
    default: {
      send_timing: 1,
      send_timing_hour: '0.0',
      stamp_type: 'A',
      stamp_width: 80
    },
    complete_flag: {
      off: 0,
      on: 1
    },
    del_flag: {
      off: 0,
      on: 1
    },
    deli_date_type: {
      reception_day: 0,
      every_week: 1,
      every_month: 2,
      other: 3
    },
    facility_type: {
      person: 1 // 個人宅
    },
    stamp_types: [
      {id: 'A', text: '', svg: "<svg width='300'  height='160' xmlns='http://www.w3.org/2000/svg'><!-- Created with SVG-edit - https://svg-edit.googlecode.com/ --><g display='inline'>    <title>Layer 1</title>    <text fill='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='65' y='52' id='svg_7' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' transform='matrix(1,0,0,1.25,0,-9.75) ' stroke='#000000'></text>    <rect id='svg_1' height='156' width='116' y='2' x='2' fill-opacity='0' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke='#000000' fill='#000000'></rect>    <text id='label_stamp_date' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='28' x='63' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>H○/○/○(曜日)</text>    <text id='label_stamp_name' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='59' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>きらり太郎　様</text>    <text id='label_stamp_time' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='87' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>朝食後</text></g></svg>"},
      {id: 'B', text: '', svg: "<svg width='300'  height='160' xmlns='http://www.w3.org/2000/svg'><!-- Created with SVG-edit - https://svg-edit.googlecode.com/ --><g display='inline'>    <title>Layer 1</title>    <text fill='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='65' y='52' id='svg_7' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' transform='matrix(1,0,0,1.25,0,-9.75) ' stroke='#000000'></text>    <rect id='svg_1' height='156' width='116' y='2' x='2' fill-opacity='0' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke='#000000' fill='#000000'></rect>    <text id='label_stamp_name' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='59' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>きらり太郎　様</text>    <text id='label_stamp_time' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='87' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>朝食後</text>    <text id='label_stamp_clinic' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='115' x='60' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>◯◯クリニック</text></g></svg>"},
      {id: 'C', text: '', svg: "<svg width='300'  height='160' xmlns='http://www.w3.org/2000/svg'><!-- Created with SVG-edit - https://svg-edit.googlecode.com/ --><g display='inline'>    <title>Layer 1</title>    <text fill='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='65' y='52' id='svg_7' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' transform='matrix(1,0,0,1.25,0,-9.75) ' stroke='#000000'></text>    <rect id='svg_1' height='156' width='116' y='2' x='2' fill-opacity='0' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke='#000000' fill='#000000'></rect>    <text id='label_stamp_name' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='59' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>きらり太郎　様</text>    <text id='label_stamp_time' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='87' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>朝食後</text></g></svg>"},
      {id: 'D', text: '', svg: "<svg width='300'  height='160' xmlns='http://www.w3.org/2000/svg'><!-- Created with SVG-edit - https://svg-edit.googlecode.com/ --><g display='inline'>    <title>Layer 1</title>    <text fill='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='65' y='52' id='svg_7' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' transform='matrix(1,0,0,1.25,0,-9.75) ' stroke='#000000'></text>    <rect id='svg_1' height='156' width='116' y='2' x='2' fill-opacity='0' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke='#000000' fill='#000000'></rect>    <text id='label_stamp_name' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='59' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>きらり太郎　様</text>    <text id='label_stamp_time' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='87' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>朝食後</text>    <text id='label_stamp_clinic' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='115' x='60' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>◯◯クリニック</text>    <text id='label_stamp_medicine' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='140' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>薬品名</text></g></svg>"},
      {id: 'E', text: '', svg: "<svg width='300' height='160' xmlns='http://www.w3.org/2000/svg'><!-- Created with SVG-edit - https://svg-edit.googlecode.com/ --><g display='inline'>    <title>Layer 1</title>    <text stroke='#000000' transform='matrix(1,0,0,1.25,0,-9.75) ' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' id='svg_7' y='52' x='65' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' fill='#000000'></text>    <rect fill='#000000' stroke='#000000' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' fill-opacity='0' x='2' y='2' width='116' height='156' id='svg_1'></rect>    <text id='label_stamp_date' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='48' x='63' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>H○/○/○(曜日)</text>    <text fill='#000000' stroke='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='61' y='79' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' id='label_stamp_name'>きらり太郎　様</text>    <text fill='#000000' stroke='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='61' y='107' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' id='label_stamp_time'>朝食後</text>    <text fill='#000000' stroke='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='60' y='135' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' id='label_stamp_medicine'>◯◯クリニック</text>    <rect fill='#ff0000' stroke='#000000' stroke-width='null' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' stroke-opacity='0' x='0' y='14' width='121' height='7' id='line'></rect></g></svg>"},
      {id: 'G', text: '', svg: "<svg width='300'  height='160' xmlns='http://www.w3.org/2000/svg'><!-- Created with SVG-edit - https://svg-edit.googlecode.com/ --><g display='inline'>    <title>Layer 1</title>    <text fill='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='65' y='52' id='svg_7' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' transform='matrix(1,0,0,1.25,0,-9.75) ' stroke='#000000'></text>    <rect id='svg_1' height='156' width='116' y='2' x='2' fill-opacity='0' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke='#000000' fill='#000000'></rect>    <text id='label_stamp_name' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='59' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>H○/○/○(曜日)</text>    <text id='label_stamp_time' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='87' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>きらり太郎　様</text>    <text id='label_stamp_method' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='115' x='60' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>朝食後</text>    <text id='label_stamp_clinic' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='140' x='61' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>◯◯クリニック</text>    <rect id='line' height='20' width='121' y='8' x='0' stroke-opacity='0' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='null' stroke='#000000' fill='#ff0000'></rect></g></svg>"},
      {id: 'I', text: '', svg: "<svg width='300' height='160' xmlns='http://www.w3.org/2000/svg'><!-- Created with SVG-edit - https://svg-edit.googlecode.com/ --><g display='inline'>    <title>Layer 1</title>    <rect fill='#000000' stroke='#000000' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' fill-opacity='0' x='2' y='2' width='116' height='156' id='svg_1'></rect>    <text id='label_stamp_date' xml:space='preserve' text-anchor='middle' font-family='serif' font-size='15' y='48' x='63' stroke-linecap='null' stroke-linejoin='null' stroke-dasharray='null' stroke-width='0' stroke='#000000' fill='#000000'>H○/○/○(曜日)</text>    <text fill='#000000' stroke='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='61' y='79' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' id='label_stamp_name'>きらり太郎　様</text>    <text fill='#000000' stroke='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='61' y='107' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' id='label_stamp_time'>朝食後</text>    <text fill='#000000' stroke='#000000' stroke-width='0' stroke-dasharray='null' stroke-linejoin='null' stroke-linecap='null' x='60' y='135' font-size='15' font-family='serif' text-anchor='middle' xml:space='preserve' id='label_stamp_medicine'>◯◯クリニック</text></g></svg>"}
    ],
    pays: [
      {pay_code: '1', pay_name: '引落', facility_pay_id: null, pdf_format: null, pdf_option: 0, del_flag: 0},
      {pay_code: '2', pay_name: '振込', facility_pay_id: null, pdf_format: null, pdf_option: 0, del_flag: 0},
      {pay_code: '3', pay_name: '都度現金', facility_pay_id: null, pdf_format: null, pdf_option: 0, del_flag: 0},
      {pay_code: '4', pay_name: '月締現金', facility_pay_id: null, pdf_format: null, pdf_option: 0, del_flag: 0},
      {pay_code: '5', pay_name: 'カード', facility_pay_id: null, pdf_format: null, pdf_option: 0, del_flag: 0}
    ]
  },
  // クリニック
  clinic: {
    default: {
      send_timing: 1, // 1週間まとめて
      send_timing_hour: '0.0'
    }
  },
  // 介護支援事業所
  careoffices: {
    default: {
      send_timing: 1, // 1週間まとめて
      send_timing_hour: '0.0'
    }
  },
  // 通知時間
  notifyShowTime: {
    normal: 5000,
    short: 3000,
    long: 10000
  },
  // 送付方法
  send_type: {
    postal: 1,
    fax: 2,
    email: 4
  },
  // 送付先
  send_to: {
    doctor: 0, // 医師
    careman: 1, // ケアマネージャー
    renmei: 2, // 連名
    history: 3, // 薬歴用
    headeronly: 4, // 送付状出力用
    facility: 5 // 施設
  },
  // 支払方法
  pay_method: {
    cach: 1
  },
  // 印刷系
  print_delete_time: 5000, // 削除待ち時間
  // 施設等画像登録可能数
  place_image_upload_limit: 5
}

export default constant



// WEBPACK FOOTER //
// ./src/store/constant.js